import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { FolderOpenOutlined } from "@ant-design/icons";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Table,
  Tooltip,
  Button,
  Form,
  Spin,
  Row,
  Col,
  Input,
  Modal,
  Divider,
  Select,
  DatePicker,
  InputNumber,
} from "antd";
import { EditOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../../security.config";
import styles from "../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const Email = (props) => {
  const navigate = useNavigate();

  const { configList, userData, refreshList, useForm } = props;

  const columns = [
    {
      title: labelConfig.name,
      dataIndex: "name",
      sorter: (a, b) => a["name"].localeCompare(b["name"]),
    },
    {
      title: labelConfig.value,
      dataIndex: "value",
    },
  ];

  return (
    <>
      <Row>
        {BOM.HasPermission("UPDATE_TWOFACTOR_CONFIGURATION") && (
          <EditEmail
            userData={userData}
            refreshList={refreshList}
            useForm={useForm}
          />
        )}
      </Row>
      <Divider orientation="left" />

      <Table columns={columns} dataSource={configList} />
    </>
  );
};

export default Email;

const EditEmail = (props) => {
  const { currentCustomerObj, userData, refreshList, useForm } = props;
  const { session } = userData;
  const { TextArea } = Input;
  const navigate = useNavigate();

  // const [useForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmitLimit = (formValues) => {
    const url = `${apiConfig.TwoFactor}/configure`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateEmailMsg);

          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate("/sms0100");
          refreshList();
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <EditOutlined />
        &nbsp;{labelConfig.edit}
      </Button>
      <Modal
        title="Edit Email"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm} onFinish={onSubmitLimit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.otpDeliveryEmailBody}
                name={labelConfig.otpDeliveryEmailBody}
              >
                <TextArea
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.otpDeliveryEmailBody
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.otpDeliveryEmailSubject}
                name={labelConfig.otpDeliveryEmailSubject}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.otpDeliveryEmailSubject
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.otpDeliveryEmailEnable}
                name={labelConfig.otpDeliveryEmailEnable}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.otpDeliveryEmailEnable} *`,
                    "select"
                  )}
                  options={staticConfig.trueOrFalseData}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};
